'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var Picker = _interopDefault(require('../picker'));
var SuspendMenu = _interopDefault(require('../suspend-menu'));
var ButtonJustify = _interopDefault(require('../button-justify'));

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('suspend-menu', {
      staticClass: "selector",
      attrs: {
        "show": _vm.show
      },
      on: {
        "clickMask": function clickMask($event) {
          _vm.$emit('hide');
        }
      }
    }, [_c('button-justify', {
      attrs: {
        "left": "取消",
        "right": "确认"
      },
      on: {
        "clickLeft": function clickLeft($event) {
          _vm.$emit('cancel');
        },
        "clickRight": function clickRight($event) {
          _vm.$emit('confirm', _vm.options[_vm.selected]);
        }
      }
    }), _vm._v(" "), _c('picker', {
      attrs: {
        "options": _vm.options
      },
      model: {
        value: _vm.selected,
        callback: function callback($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    })], 1);
  },
  staticRenderFns: [],
  name: 'selector',
  props: {
    show: Boolean,
    options: Array,
    startPosition: Number
  },
  components: {
    Picker: Picker,
    SuspendMenu: SuspendMenu,
    ButtonJustify: ButtonJustify
  },
  data: function data() {
    return {
      selected: 0
    };
  },
  mounted: function mounted() {
    this.selected = this.startPosition || 0;
  }
});

exports.default = index;
